import React, { useCallback, useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { popupType } from "../../../../types/types";
import moment from "moment";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import "./DateFilter.css";
import { dateFilter, reportListObject } from "../../types/types";
import { convertPeriodToDate } from "../../../../services/reportService";
import { GenericPopUp } from "../../../../components/popup/genericPopUp";
import PeriodFilter from "./PeriodFilter";
import MonthYearFilter from "./MonthYearFilter";
import DateRangeFilter from "./DateRangeFilter";
import DateRangeAndPeriodSelection from "./DateAndPeriodFilter";
import LiveFilterComponent from "./LiveFilterComponent";
import { useReportGlobalFilters } from "../../../../providers/ReportGlobalFiltersProvider";
import store from "../../../../stateManagement/store";
import { TranslationEnum, usePortalTranslation } from "../../../../providers/TranslationProvider";
import { useSelector } from "react-redux";
import QuarterFilter from "./QuarterFilter";
import { isGapMoreThanNDays } from "../../../../utils/calenderUtils";
import { configurationAttributeType } from "../../../../types";
import { getMetaDataConfig } from "../../../../services/uiConfigService";

const DateFilter: React.FC<reportListObject & dateFilter> = ({
  filter,
  selectedParentFilter,
  setStartDateForAttribute,
  setEndDateForAttribute,
  setResetFiltersFlag,
  setYearForAttribute,
  setPeriodForAttribute,
  selectedLiveFilter,
  setSelectedLiveFilter,
  allowFutureDate
  // setQuarterForAttribute
}) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const [startDate, setStartDate] = useState<Dayjs>(dayjs());
  const [endDate, setEndDate] = useState<Dayjs>(dayjs());
  const [period, setPeriod] = useState<string>("");
  // const [quarter, setQuarter] = useState<string>("");
  const [year, setYear] = useState<string>("");
  const [month, setMonth] = useState<string>("");
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [options, setOptions] = useState<any>([]);
  // const [quarterOptions, setQuarterOptions] = useState<any>([1,2,3,4]);
  const [tabValue,setTabValue] = useState<"1" | "2">("1"); 
  const [dateRange, setDateRange] = useState<number>(31);
  const currentYearDefault = new Date().getFullYear();
  const previousYearDefault = currentYearDefault - 1;
  const [yearOptions, setYearOptions] = useState<number[]>([previousYearDefault, currentYearDefault]);
  // selectedLiveFilter is now passed as a prop
      useEffect(() => {
      const fetchPortalConfig = async () => {
        
        const portalConfig:any = await getMetaDataConfig(
          "clientconfig",
          "portal_configuration"
        );
        const portal_config: configurationAttributeType[] =
          portalConfig?.domainValues ?? [];
      
        const dateRangeConfig = portal_config?.find(
          (item) => item.name === "dateRange"
        )?.value ?? 31;
        setDateRange(dateRangeConfig);
        const yearOptionsConfig = portal_config?.find(
          (item) => item.name === "yearOptions"
        )?.value as string | undefined;
        
        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;
        const nextYear = currentYear + 1;
        
        let configuredYearOptions: number[] = [];
        
        if (yearOptionsConfig && typeof yearOptionsConfig === 'string') {
          const yearConfigArray = yearOptionsConfig.split(',').map((item: string) => item.trim().toLowerCase());
          
          yearConfigArray.forEach((option: string) => {
            if (option === 'nextyear' || option === 'next') {
              configuredYearOptions.push(nextYear);
            } else if (option === 'currentyear' || option === 'current') {
              configuredYearOptions.push(currentYear);
            } else if (option === 'previousyear' || option === 'previous') {
              configuredYearOptions.push(previousYear);
            }
          });
        }
        
        if (configuredYearOptions.length === 0) {
          configuredYearOptions = [previousYear, currentYear];
        }
        
        setYearOptions(configuredYearOptions);
      };
      fetchPortalConfig();
    }, []);

  const { setReportGlobalFiltersState } = useReportGlobalFilters();
  const numberOfPeriods = useSelector(() => store.getState()?.fileFormat?.config?.numberOfPeriods) ?? 13;
  useEffect(() => {
    let newOptions = [];
    for (let i = 1; i <= numberOfPeriods; i++) {
      newOptions.push(i);
    }
    setOptions(newOptions);
  }, []);
  const handleClearAll = () => {
    // For newFilter (Live filter), reset dates based on currently selected filter
    if (filter === "newFilter" && selectedLiveFilter) {
      // Keep the selected filter, only reset dates to default for that filter
      if (selectedLiveFilter === 'past7days') {
        const end = dayjs();
        const start = end.subtract(7, 'day');
        setStartDate(start);
        setEndDate(end);
      } else if (selectedLiveFilter === 'past3months') {
        const end = dayjs().subtract(1, 'day');
        const start = end.subtract(3, 'month');
        setStartDate(start);
        setEndDate(end);
      } else if (selectedLiveFilter === 'custom') {
        const yesterday = dayjs().subtract(1, 'day');
        setStartDate(yesterday);
        setEndDate(yesterday);
      }
      // Don't reset selectedLiveFilter - keep it as is
    } else {
      // For other filters, reset normally
      setStartDate(dayjs());
      setEndDate(dayjs());
      if (setSelectedLiveFilter) {
        setSelectedLiveFilter("");
      }
    }
    
    setPeriod("");
    setYear("");
    setMonth("");
    if(setYearForAttribute){
      setYearForAttribute("");
    }
    if(setPeriodForAttribute){
    setPeriodForAttribute("")
    }  
    // if(setQuarterForAttribute){
    //   setQuarterForAttribute("")
    //   } 
    if(setResetFiltersFlag) setResetFiltersFlag((prevValue) => !prevValue);
  };


  const handleChangeYear = (event: SelectChangeEvent) => {
    setYear(event.target.value);
    if(setYearForAttribute){
      setYearForAttribute(event.target.value)
    }
  };


  const convertMonthYearToDateRange = (month: string, year: string) => {
    const start = moment(`${year}-${month}-01`);
    const end = moment(start).endOf("month");
    return [start, end];
  };

  async function periodFilterApply(){
    const response = await convertPeriodToDate(period, year);
    setStartDateForAttribute(response.features[0].startDate);
    setEndDateForAttribute(response.features[0].endDate);
  }
  const handleApply = async () => {
    let response;
    if(setResetFiltersFlag) setReportGlobalFiltersState(store?.getState()?.genericFilter) // setResetFiltersFlag will not be undefined only when globalFilters are present
    switch (filter){
      case "periodfilter":
      response = await convertPeriodToDate(period, year);
      setStartDateForAttribute(response.features[0].startDate);
      setEndDateForAttribute(response.features[0].endDate);
      break;
      case "monthyear":
      const [start, end] = convertMonthYearToDateRange(month, year);
      let startd = moment(start.toISOString()).format("YYYY-MM-DD 00:00:00");
      let endd = moment(end.toISOString()).format("YYYY-MM-DD 23:59:59");
      setStartDateForAttribute(startd);
      setEndDateForAttribute(endd);
      break;
      case "daterangeAndPeriod": {
        if(tabValue === "1"){
          if (canWeMakeRequest()) {
            const start = moment(startDate.toISOString()).format(
              "YYYY-MM-DD 00:00:00"
            );
            const end = moment(endDate.toISOString()).format("YYYY-MM-DD 23:59:59");
            setStartDateForAttribute(start);
            setEndDateForAttribute(end);
          }
        }else if(tabValue === "2"){
          response = await convertPeriodToDate(period, year);
          setStartDateForAttribute(response.features[0].startDate);
          setEndDateForAttribute(response.features[0].endDate);
        }
        break;
      }
      case "newFilter": {
        if (canWeMakeRequest()) {
          const start = moment(startDate.toISOString()).format(
            "YYYY-MM-DD 00:00:00"
          );
          const end = moment(endDate.toISOString()).format("YYYY-MM-DD 23:59:59");
          setStartDateForAttribute(start);
          setEndDateForAttribute(end);
        }
        break;
      }
      default:
      if (canWeMakeRequest()) {
        const start = moment(startDate.toISOString()).format(
          "YYYY-MM-DD 00:00:00"
        );
        const end = moment(endDate.toISOString()).format("YYYY-MM-DD 23:59:59");
        setStartDateForAttribute(start);
        setEndDateForAttribute(end);
      }
      break;
    }
  };

  const isStartDateIsGreaterThanEndDate = (
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs
  ) => {
    const diff = endDate.diff(startDate);
    return diff < 0;
  };

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const validDateRange = dateRange ?? 31;
  function canWeMakeRequest() {
    const isLiveFilterCustomRange = filter === "newFilter" && selectedLiveFilter === "custom";
    
    if (!isLiveFilterCustomRange) {
      const maxAllowedDays = (filter === "newFilter" && selectedLiveFilter && selectedLiveFilter !== "custom") ? 92 : validDateRange;
      
      if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, maxAllowedDays)) {
        openPopup(`You can't select date range more than ${maxAllowedDays} days!`, "Alert");
        return false;
      }
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      openPopup("To Date should be greater than from date.", "Alert");
      return false;
    }
    return true;
  }

  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);
  useEffect(()=>{
    if(setPeriodForAttribute){
      setPeriodForAttribute(period)
    }
    // if(setQuarterForAttribute){
    //   setQuarterForAttribute(quarter)
    // }
  },[period])
  useEffect(()=>{
    if(setPeriodForAttribute){
      setPeriodForAttribute("")
    }
    // if(setQuarterForAttribute){
    //   setQuarterForAttribute("")
    // }
    if(setYearForAttribute){
      setYearForAttribute("");
    }
  },[startDate,endDate])

  useEffect(()=>{
    setEndDate(dayjs());
    setStartDate(dayjs());
  },[selectedParentFilter])

  const minDate: Dayjs | undefined =(selectedParentFilter && selectedParentFilter.restriction) ? dayjs().subtract(selectedParentFilter.restriction.value, selectedParentFilter.restriction.type) : undefined ;

  return (
    <div className="date-filters">
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      
      {filter == "daterange" && (
        <DateRangeFilter allowFutureDate={allowFutureDate} minDate={minDate} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
        // <div className="dates-daterange">
        //   <LocalizationProvider
        //     dateAdapter={AdapterDayjs}
        //     className="dateEnter"
        //   >
        //     <DatePicker
        //       label="From Date"
        //       inputFormat="DD-MM-YYYY"
        //       value={startDate}
        //       maxDate={dayjs()}
        //       onChange={(value) => {
        //         if (value) {
        //           setStartDate(value);
        //         }
        //       }}
        //       renderInput={(props) => (
        //         <TextField {...props} disabled size="small" />
        //       )}
        //     />
        //   </LocalizationProvider>
        //   <LocalizationProvider dateAdapter={AdapterDayjs}>
        //     <DatePicker
        //       label="To Date"
        //       inputFormat="DD-MM-YYYY"
        //       value={endDate}
        //       maxDate={dayjs()}
        //       onChange={(value) => {
        //         if (value) {
        //           setEndDate(value);
        //         }
        //       }}
        //       renderInput={(props) => (
        //         <TextField {...props} disabled size="small" />
        //       )}
        //     />
        //   </LocalizationProvider>
        // </div> 
      )}
      {filter == "periodfilter" && (
        <PeriodFilter yearOptions={yearOptions} year={year} period={period} setPeriod={setPeriod} handleChangeYear={handleChangeYear} periodOptions={options} />
        // <div className="dates-periodrange">
        //   <FormControl>
        //     <InputLabel id="demo-simple-select-label">Period</InputLabel>
        //     <Select
        //       labelId="demo-simple-select-label"
        //       id="demo-simple-select"
        //       value={period}
        //       label="Period"
        //       onChange={handleChangePeriod}
        //     >
        //       {options.map((option: any) => (
        //         <MenuItem key={option} value={option}>
        //           Period {option}
        //         </MenuItem>
        //       ))}
        //     </Select>
        //   </FormControl>
        //   <FormControl>
        //     <InputLabel id="demo-simple-select-label">Year</InputLabel>
        //     <Select
        //       labelId="demo-simple-select-label"
        //       id="demo-simple-select"
        //       value={year}
        //       label="Year"
        //       onChange={handleChangeYear}
        //     >
        //       <MenuItem value={currentYear}>{currentYear}</MenuItem>
        //       <MenuItem value={previousYear}>{previousYear}</MenuItem>
        //     </Select>
        //   </FormControl>
        // </div>
      )}

      {filter == "quarterfilter" && (
        <QuarterFilter yearOptions={yearOptions} year={year} handleChangeYear={handleChangeYear} />
      )}
      {filter == "monthyear" && (
        <MonthYearFilter yearOptions={yearOptions} year={year} month={month} setMonth={setMonth} handleChangeYear={handleChangeYear} />
        // <div className="dates-monthrange">
        //   <FormControl>
        //     <InputLabel id="demo-simple-select-label">Month</InputLabel>
        //     <Select
        //       labelId="demo-simple-select-label"
        //       id="demo-simple-select"
        //       value={month}
        //       label="Month"
        //       onChange={handleChangeMonth}
        //     >
        //       <MenuItem value={1}>January</MenuItem>
        //       <MenuItem value={2}>February</MenuItem>
        //       <MenuItem value={3}>March</MenuItem>
        //       <MenuItem value={4}>April</MenuItem>
        //       <MenuItem value={5}>May</MenuItem>
        //       <MenuItem value={6}>June</MenuItem>
        //       <MenuItem value={7}>July</MenuItem>
        //       <MenuItem value={8}>August</MenuItem>
        //       <MenuItem value={9}>September</MenuItem>
        //       <MenuItem value={10}>October</MenuItem>
        //       <MenuItem value={11}>November</MenuItem>
        //       <MenuItem value={12}>December</MenuItem>
        //     </Select>
        //   </FormControl>
        //   <FormControl>
        //     <InputLabel id="demo-simple-select-label">Year</InputLabel>
        //     <Select
        //       labelId="demo-simple-select-label"
        //       id="demo-simple-select"
        //       value={year}
        //       label="Year"
        //       onChange={handleChangeYear}
        //     >
        //       <MenuItem value={currentYear}>{currentYear}</MenuItem>
        //       <MenuItem value={previousYear}>{previousYear}</MenuItem>
        //     </Select>
        //   </FormControl>
        // </div>
      )}
      {filter==="daterangeAndPeriod" && (
        <DateRangeAndPeriodSelection allowFutureDate={allowFutureDate} minDate={minDate} tabValue={tabValue} setTabValue={setTabValue} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} yearOptions={yearOptions} year={year} period={period} setPeriod={setPeriod} handleChangeYear={handleChangeYear} periodOptions={options} />
      )}
      {filter==="newFilter" && (
        <LiveFilterComponent 
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          selectedFilter={selectedLiveFilter || ""}
          setSelectedFilter={setSelectedLiveFilter || (() => {})}
          minDate={minDate}
          selectedParentFilter={selectedParentFilter}
        />
      )}
      {tabValue == "1" && (filter == "daterange" || filter == "daterangeAndPeriod") && selectedParentFilter && selectedParentFilter.note && (
        <div className="daterange-disclaimer">
          {selectedParentFilter.note}
        </div>
      )}
      <div className="reset-and-apply-button">
      <Button
          variant="contained"
          sx={{ backgroundColor: "#ffffff", color: "#237C9D", border: "1px solid #237C9D", borderRadius: "12px"}}
          onClick={handleClearAll}
        >
          {translate(TranslationEnum.common_portal,"Reset")}
        </Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#237C9D", borderRadius: "12px" }}
          onClick={handleApply}
        >
          {translate(TranslationEnum.common_portal,"Apply")}
        </Button>
      
      </div>
    </div>
  );
};
export default DateFilter;
